import { useMutation } from '@tanstack/react-query';
import { Employee } from '../../../types/Employee';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';
import { AxiosError } from 'axios';
import { mutationKeys } from '../mutationKeys';

export const postEmployee = async (formData: Employee) => {
  const response = await CustomAxios.post(`employees`, formData);
  const { data } = response;
  return data;
};

type useCreateEmployeeProps = {
  onSuccessCallback: (data: Employee) => void;
};
export function useCreateEmployee({ onSuccessCallback }: useCreateEmployeeProps) {
  return useMutation({
    mutationKey: [mutationKeys.createEmployee],
    mutationFn: (formData: Employee) => postEmployee(formData),
    onSuccess: (data: Employee) => {
      // fetch the employees again after create
      queryClient.invalidateQueries({ queryKey: [queryKeys.allEmployees, 'new'] });

      // call success
      onSuccessCallback(data);
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        // let set the query data with bad errored response
        const employee: Employee = err.response.data as Employee;
        queryClient.setQueryData([queryKeys.allEmployees, 'new'], employee);
      }
    },
  });
}
